import {AUTH} from "@/config/enum";
import {isRcsProject} from "@/utils";
const isRcs = isRcsProject();

export default  [
    {to: "/backend/dashboard", text: "首页面板", icon: "wq-dashboard"},
    {to: "/backend/customer", text: "客户管理",icon: "wq-customer", children: [
        {to: "/backend/customer/list", text: "客户管理"},
        {to: "/backend/customer/recharge/add", text: "客户充值记录"},
        {to: "/backend/customer/recharge/deduct", text: "客户扣值记录"},
        {to: "/backend/customer/consume", text: "客户消耗记录"},
        {to: "/backend/customer/authentication", text: "客户认证"},
        {to: "/backend/customer/log", text: "客户登录日志", auth: [AUTH.ADMIN]}
    ]},
    {to: "/backend/rcs/message", text: isRcs ? "消息管理" : "RCS管理", icon: "wq-telegram", children: [
        {to: "/backend/rcs/message/1", text: "消息审核"},
        {to: "/backend/rcs/message/20", text: "待发送"},
        {to: "/backend/rcs/message/21", text: "发送中"},
        {to: "/backend/rcs/message/22", text: "发送结束"}
    ]},
    {to: "/backend/ws/message", hide: isRcs, text: "WS管理", icon: "wq-whatsapp", children: [
        {to: "/backend/ws/message/1", text: "消息审核"},
        {to: "/backend/ws/message/20", text: "待发送"},
        {to: "/backend/ws/message/21", text: "发送中"},
        {to: "/backend/ws/message/22", text: "发送结束"}
    ]},
    {to: "/backend/sms/message", hide: isRcs, text: "SMS管理", icon: "wq-momo", children: [
        {to: "/backend/sms/message/1", text: "消息审核"},
        {to: "/backend/sms/message/20", text: "待发送"},
        {to: "/backend/sms/message/21", text: "发送中"},
        {to: "/backend/sms/message/22", text: "发送结束"}
    ]},
    {to: "/backend/agent", text: "费用管理", icon: "wq-finance", auth: [AUTH.AGENT], children : [
            {to: "/backend/agent/recharge/add", text: "充值记录"},
            {to: "/backend/agent/recharge/deduct", text: "扣值记录"},
            {to: "/backend/agent/consume", text: "消耗记录"}
    ]},
    {to: "/backend/product", text: "通道 & 产品", icon: "wq-api", auth: [AUTH.ADMIN], children : [
            {to: "/backend/product/api", text: "通道管理"},
            {to: "/backend/product/list", text: "产品管理"}
    ]},
    {
        to: "/backend/setting", text: "系统设置", icon: "wq-setting", auth: AUTH.ADMIN, children : [
            {to: "/backend/setting/account", text: "账号管理", auth: AUTH.ADMIN},
            {to: "/backend/setting/sms/template", text: "短信模板", auth: AUTH.ADMIN},
            {to: "/backend/setting/sms/record", text: "短信记录", auth: AUTH.ADMIN},
            {to: "/backend/setting/system", text: "系统设置", auth: AUTH.ADMIN},
        ]
    }
]
